/**
 * View-only Repack backlog. Each source retains its independent identity.
 * This is NOT an inventory ledger, receiving-event report, or save payload.
 */
const whole = (value) => Math.max(0, Math.trunc(Number(value) || 0));

export function buildReadyRepackRows(purchaseSources = [], conversionSources = []) {
  const purchases = purchaseSources.filter((s) => whole(s.remaining_repack_qty) > 0).map((s) => ({
    key: `PURCHASE:${s.purchase_item_id}`,
    date: s.purchase_date || "",
    source: s.purchase_no || "Purchase",
    sourceType: "PURCHASE",
    sku: s.sku_code || "",
    total: whole(s.received_good_qty),
    remaining: whole(s.remaining_repack_qty),
    note: s.description || "",
  }));
  const conversions = conversionSources.filter((s) => s.status === "POSTED" && whole(s.remaining_repack_qty) > 0).map((s) => ({
    key: `CONVERSION:${s.id}`,
    date: (s.created_at || "").slice(0, 10),
    source: s.transfer_no || "Konversi",
    sourceType: "CONVERSION",
    sku: s.to_sku || "",
    total: whole(s.qty),
    remaining: whole(s.remaining_repack_qty),
    note: s.from_sku ? `Dari ${s.from_sku}` : "",
  }));
  return [...purchases, ...conversions].sort((a, b) =>
    a.date.localeCompare(b.date) || a.source.localeCompare(b.source) || a.sku.localeCompare(b.sku) || a.key.localeCompare(b.key)
  );
}
